import { useTranslation } from "react-i18next";

export default function ResultPreviewCard({
  favicon,
  name,
  urlSlug,
  metaTitle,
  metaDesc,
}) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex items-center gap-1 md:gap-4 w-full break-words !font-Arial ">
        {favicon ? (
          <img
            src={favicon}
            alt={`${name} favicon`}
            className="h-7 w-7 rounded-full"
          />
        ) : (
          <div className="h-7 w-7 bg-slate-300 flex-shrink-0 rounded-full" />
        )}
        <div className="text-slate-600 ">
          <p className="text-sm font-normal ">
            {name ? name : t("Your-website", "Mon Site Web")}
          </p>
          <p className="text-xs font-normal">{urlSlug}</p>
        </div>
      </div>
      <div className="mt-2">
        <p className="text-xl text-blue-800 font-normal !font-Arial">
          {metaTitle ? metaTitle : "Mon meta title ..."}
        </p>
        <p className="text-slate-600 text-sm font-normal !font-Arial">
          {metaDesc ? metaDesc : "Ma meta description ..."}
        </p>
      </div>
    </>
  );
}
